import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
	  alertBox:{
		  type:false,
		  title:"",
		  content:"",
	  },
		  pageList:[],
		  project:[],
	  },
  mutations: {
	  upAlertBox(state,data){
		  state.alertBox=data;
	  },
	  upPageList(state,data){
		  console.log(data)
		  state.pageList=data;
	  },
	  upProject(state,data){
		  state.project=data;
	  },
  },
  actions: {},
  modules: {}
});
